import axios from 'axios';
import React, { useState } from 'react';
import { render } from 'react-dom';
import './Book.css';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {Accordion, AccordionBody, AccordionHeader, AccordionItem} from "react-headless-accordion";
import NumericInput from 'react-numeric-input';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { DesktopTimePicker } from '@mui/x-date-pickers/DesktopTimePicker';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';


function Book({ children }) {
  const [menuSelection, setMenuSelection] = useState('');
  const [openIndex, setOpenIndex] = useState(0);
  const [rezMethod, setRezMethod] = useState(null);
  const [numberValue, setNumberValue] = useState(2);
  const [selectedDate, setSelectedDate] = React.useState(dayjs());
  const [selectedTimeValue, setSelectedTimeValue] = useState("");
  const [selectedRoom, setSelectedRoom] = useState("No Preference"); // default
  const [open, setOpen] = React.useState(false);
  const [guestsOpen, setGuestsOpen] = useState([]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleRoomChange = (event) => {
    setSelectedRoom(event.target.value);
  };

  const style = {
    position: 'absolute',
    top: '32%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '1px solid black',
    boxShadow: 'black 0px 50px 100px -20px, black 0px 30px 60px -30px;',
    borderRadius: 0,
    zIndex: 1000000000,
    p: 8,
  };

  const Settings = {
    dots: false,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    LazyLoad: true,
    fade: true,
    initialSlide: 0
  };

  const handleRezMethodClick = (value) => {
    setRezMethod(value);
    if (value == "Phone"  && 
      document.getElementById("phone-method").style.boxShadow != "rgb(42, 1, 1) 0px 25px 45px inset" && 
      document.getElementById("walk-in-method").style.boxShadow != "rgb(42, 1, 1) 0px 25px 45px inset") 
    {
      document.getElementById("phone-method").style.boxShadow = "rgb(42, 1, 1) 0px 25px 45px inset";
      setGuestsOpen(['item-2']);

      alert(guestsOpen)
    } else if (value == "Phone" && 
      document.getElementById("phone-method").style.boxShadow == "rgb(42, 1, 1) 0px 25px 45px inset"  && 
      document.getElementById("walk-in-method").style.boxShadow != "rgb(42, 1, 1) 0px 25px 45px inset") 
    { 
      document.getElementById("phone-method").style.boxShadow = "rgb(42, 1, 1) 0px 25px 45px";
      document.getElementById("walk-in-method").style.boxShadow = "rgb(42, 1, 1) 0px 25px 45px"

    } else if (value == "Walk-Up" && 
      document.getElementById("phone-method").style.boxShadow != "rgb(42, 1, 1) 0px 25px 45px inset" &&
      document.getElementById("walk-in-method").style.boxShadow != "rgb(42, 1, 1) 0px 25px 45px inset")
      { 
      document.getElementById("walk-in-method").style.boxShadow = "rgb(42, 1, 1) 0px 25px 45px inset"; 
      handleOpen();
    } else if (value == "Walk-Up" &&
      document.getElementById("phone-method").style.boxShadow != "rgb(42, 1, 1) 0px 25px 45px inset" &&
      document.getElementById("walk-in-method").style.boxShadow == "rgb(42, 1, 1) 0px 25px 45px inset")
      { document.getElementById("walk-in-method").style.boxShadow = "rgb(42, 1, 1) 0px 25px 45px"; 
    } else if (value == "Walk-Up" &&
        document.getElementById("phone-method").style.boxShadow == "rgb(42, 1, 1) 0px 25px 45px inset" &&
        document.getElementById("walk-in-method").style.boxShadow != "rgb(42, 1, 1) 0px 25px 45px inset")
      { document.getElementById("walk-in-method").style.boxShadow = "rgb(42, 1, 1) 0px 25px 45px inset"; 
        document.getElementById("phone-method").style.boxShadow = "rgb(42, 1, 1) 0px 25px 45px";
    } else if (value == "Phone" &&
      document.getElementById("phone-method").style.boxShadow != "rgb(42, 1, 1) 0px 25px 45px inset" &&
      document.getElementById("walk-in-method").style.boxShadow == "rgb(42, 1, 1) 0px 25px 45px inset")
      { document.getElementById("walk-in-method").style.boxShadow = "rgb(42, 1, 1) 0px 25px 45px"; 
        document.getElementById("phone-method").style.boxShadow = "rgb(42, 1, 1) 0px 25px 45px inset";
      };
  };

  const handleNumberChange = (value) => {
    if (document.getElementById("phone-method").style.boxShadow != "rgb(42, 1, 1) 0px 25px 45px inset" && 
    document.getElementById("walk-in-method").style.boxShadow != "rgb(42, 1, 1) 0px 25px 45px inset") {
      alert("Phoned In or Walked?")
    }
    setNumberValue(value); 
  };

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  const CustomLeftArrow = ({ onClick }) => (
    <button
      onClick={onClick}
      className="absolute left-4 top-1/2 -translate-y-1/2 bg-gray-700 text-white p-3 rounded-full shadow-md hover:bg-gray-900"
    >
      <FaChevronLeft size={20} />
    </button>
  );  

  const handleDateChange = (newDate) => {
    setSelectedDate(newDate);
  };

  const handleTimeClick = (value) => {
    setSelectedTimeValue(value);
    alert("Time Preferred: " + selectedTimeValue)
  };


const MyAccordion = () => {
  const [openIndex, setOpenIndex] = useState(0); // 0 means first item open
}

const shouldDisableDate = (day) => {
  return day.day() === 1 || day.day() === 2 || day.isBefore(dayjs(), 'day'); // Monday (Sunday=0, Monday=1, ... Saturday=6)
};

  return (
    <span className="home-page" id="main-home-div">
      <div className="date-picker-container">
        {/* <img className="lantern" src="lantern-3.jpg"/> */}
        {/* <div className="upper-title-div">
          <text className="book-table-title-the">Harvard, Illinois</text><h3 className="heritage-house-title">HERITAGE HOUSE</h3>
          <h3 className="book-table-title">Book a Table</h3>
          <div className="upper-title-bottom-line"></div>
        </div> */}
        <div className="row g-30">
                    <div className="col-md-1"></div>
                    <div className="col-md-5" id="phone-method" onClick={() => handleRezMethodClick("Phone")}>
                      <img className="phone-in-img" src="phone.png"/><br/><br/>
                      <text className="method-label">Phone In</text><br/>
                    </div>
                    <div className="col-md-1 gutter"></div>
                    <div className="col-md-5" id="walk-in-method" onClick={() => handleRezMethodClick("Walk-Up")}>
                      <img className="walk-in-img" src="family.png"/><br/>
                      {/* <input type="checkbox" id="vehicle2" name="vehicle2" value="Car"/> */}
                      <text className="method-label">Walk-Up</text><br/>
                    </div>
                    <div className="col-md-1"></div>
                    </div>
        <Accordion defaulOpenItems={['item-2']} onChange={[]}>
            <AccordionItem as="div" className="accordion-parent" isActive={true} id="item-2">
                <AccordionHeader className="accordion-parent" id="item-2">
                  <h3 className={`accordion-title`}>1.  How many in your party?<i class="fa-light fa-chevron-down"></i></h3>
                </AccordionHeader>
                <AccordionBody className="guests-accordion-div">
                <h3 className="number-of-guests">Number of Guests</h3>
                  <div className="guests-spacer"></div>
                  <NumericInput 
                    min={1} 
                    max={50} 
                    step={1} 
                    value={numberValue} 
                    onChange={handleNumberChange}
                    buttonPlacement="both"
                    style={{
                      input: { width: 150, height: 32, textAlign: "center", fontSize: "25px", fontFamily: "TimeNewRoman", border: "1px solid rgb(42, 1, 1)"},
                      btn: { width: 50, height: 30, background: "lightblue", border: "1px solid rgb(42, 1, 1)", borderRadius: "0%", cursor: "pointer", paddingLeft: "40px", color: "white"},
                    }}
                    mobile
                    />
                    <div className="guests-accordion-spacer"></div>
                </AccordionBody>
            </AccordionItem>
            <AccordionItem>
                <AccordionHeader className="accordion-parent">
                    <h3 className={`accordion-title`}>2.  Date?  Time?  Room Preference?<i class="fa-light fa-chevron-down"></i></h3>
                </AccordionHeader>
                <AccordionBody>
                  <div className="row-date-time">
                    <div className="col-md-9">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateCalendar 
                        value={selectedDate}
                        onChange={handleDateChange} 
                        shouldDisableDate={shouldDisableDate}/>
                    </LocalizationProvider>
                  </div>
                    <div className="col-md-3">
                      <div className="time-picker">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer
                        components={[
                          'TimePicker',
                          'MobileTimePicker',
                          'DesktopTimePicker',
                          'StaticTimePicker',
                        ]}
                      >
                        <DemoItem label="Pick a Time">
                          <DesktopTimePicker defaultValue={dayjs('2022-04-17T16:00')} style={{input: {fontSize: "20px"}}}/>
                        </DemoItem>
                        </DemoContainer>
                        </LocalizationProvider><br/>
                        <form className="radio-form" action="/action_page.php">
                        <input type="radio" id="html" name="fav_language" value="Front Room" checked={selectedRoom === "Front Room"} onChange={handleRoomChange}/>
                          <label for="html">&nbsp;&nbsp;Front Room&nbsp;&nbsp;</label>
                          <input type="radio" id="back" name="fav_language" value="Back Room" checked={selectedRoom === "Back Room"} onChange={handleRoomChange}/>
                          <label for="css">&nbsp;&nbsp;Back Room&nbsp;&nbsp;</label>
                          <input type="radio" id="none" name="fav_language" value="No Preference" onChange={handleRoomChange} checked={selectedRoom === "No Preference"}/>
                        <label for="javascript">&nbsp;&nbsp;No Preference&nbsp;&nbsp;</label></form><br/><br/><br/>
                          <Carousel   className="time-carousel" centerMode={true} arrows={true} responsive={responsive}>
                            <div className="time-button" onClick={() => handleTimeClick("4:00pm")}>4:00pm</div>
                            <div className="time-button" onClick={() => handleTimeClick("4:15pm")}>4:15pm</div>
                            <div className="time-button unavailable">4:30pm</div>
                            <div className="time-button" onClick={() => handleTimeClick("5:00pm")}>5:00pm</div>
                            <div className="time-button" onClick={() => handleTimeClick("5:15pm")}>5:15pm</div>
                            <div className="time-button" onClick={() => handleTimeClick("5:30pm")}>5:30pm</div>
                            <div className="time-button" onClick={() => handleTimeClick("5:45pm")}>5:45pm</div>
                            <div className="time-button" onClick={() => handleTimeClick("6:00pm")}>6:00pm</div>
                            <div className="time-button" onClick={() => handleTimeClick("6:15pm")}>6:15pm</div>
                            <div className="time-button unavailable">6:30pm</div>
                            <div className="time-button" onClick={() => handleTimeClick("6:45pm")}>6:45pm</div>
                            <div className="time-button" onClick={() => handleTimeClick("7:00pm")}>7:00pm</div>
                            <div className="time-button" onClick={() => handleTimeClick("7:15pm")}>7:15pm</div>
                            <div className="time-button" onClick={() => handleTimeClick("7:30pm")}>7:30pm</div>
                          </Carousel>
                    </div> 
                    </div>
                  </div>

                </AccordionBody>
            </AccordionItem>
            <AccordionItem>
                <AccordionHeader className="accordion-parent">
                    <h3 className={`accordion-title`}>3.  Spcial Occassion?  Allergies?  etc.?<i class="fa-light fa-chevron-down"></i></h3>
                </AccordionHeader>
                <AccordionBody>
                  <textarea id="w3review" name="w3review" rows="4" cols="160">Any special requests?  Allergies?</textarea>
                </AccordionBody>
            </AccordionItem>
          </Accordion>
          {/* <img className="table_img" src="table_img.jpg"/> */}
        </div>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography id="modal-modal-title" variant="h6" component="h2">

                <a onClick={handleClose}><span className="w3-button w3-display-topright">&times;</span></a>
                <div className="row-seated-now">
                <text className="seated-now-title">seat them now?</text><br/>
                  <div className="seated-now-button col-md-6 right">Yes, please!</div>
                  <div className="seated-now-button col-md-6" onClick={handleClose}>No, Later.</div>
                  <div className="seat-now-spacer"></div>
                  <a onClick={handleClose} className="cancel-seat-now-modal"><text onClick={handleClose}>(cancel)</text></a>

                </div>
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              </Typography>
            </Box>
          </Modal>
        </span>
  );}

export default Book;
